import {FC, useMemo} from "react";
import Badge from "../atoms/Badge.tsx";
import {DateTime} from "luxon";

interface Props {
    date: number; // Unix timestamp in milliseconds
}

const DateBadge: FC<Props> = ({ date }) => {
    const formattedDate = useMemo(() =>
        DateTime.fromMillis(date).toFormat("ccc dd LLL HH:mm"), [date])

    return <Badge>{formattedDate}</Badge>
}

export default DateBadge;
